import React, { Dispatch, SetStateAction, useState } from "react";

import FileDetailPopup from "src/components/Folders/FileDetailPopup";
import { FileToolbarConstants } from "src/Core/Common/Constants";
import { IMyFilesFileModel } from "src/Core/ViewModels/File/MyFilesFileModel";
import { IFolderModel } from "src/Core/ViewModels/Folder/FolderModel";

interface IFileActionsPopUp {
    selectedFile: IMyFilesFileModel;
    currentFolder: IFolderModel;
    onHide?: () => void;
    setShowFileActionPopup?: Dispatch<SetStateAction<boolean>>;
    selectedFileRowId?:string;
}

const FileActionsPopUp: React.FC<IFileActionsPopUp> = ({
    selectedFile,
    onHide,
}) => {
    const [showViewDetailsModal, setShowViewDetailsModal] = useState(false);

    const handleHideViewDetailsModal = () => {
        setShowViewDetailsModal(false);
        onHide && onHide();
    };

    return (
        <div className="folder-actions-container">
            {
                <div
                    className="folder-action-wrapper"
                    onClick={() => {
                        setShowViewDetailsModal(true);
                    }}
                >
                    <span>{FileToolbarConstants.VIEW_DETAILS}</span>
                </div>
            }

            {showViewDetailsModal && (
                <FileDetailPopup
                    show={showViewDetailsModal}
                    file={selectedFile}
                    onHide={handleHideViewDetailsModal}
                />
            )}
        </div>
    );
};

export default FileActionsPopUp;
